// stores/checklist-detail-member-store.js
import { defineStore } from "pinia";
import axios from "axios";
import { API_URL } from "@/config/api";
import { withShioriAccessContext } from "@/api/shiori-access-context.js";

export const usechecklistDetailMemberAccountStore = defineStore(
  "checklistDetailMemberAccount",
  {
    state: () => ({
      checklistDetailMembers: [],
      loadedShioriId: null,
      isLoading: false,
      error: null,
    }),

    actions: {
      async fetchMembersByShiori(shioriId) {
        this.isLoading = true;
        this.error = null;
        try {
          const token = localStorage.getItem("token");
          const response = await axios.get(
            `${API_URL}/checklist_detail_member/?shiori_id=${shioriId}`,
            withShioriAccessContext(shioriId, {
              headers: { Authorization: `Bearer ${token}` },
            }),
          );
          this.checklistDetailMembers = response.data;
          this.loadedShioriId = shioriId;
        } catch (err) {
          this.error = err;
          console.error("チェックリストメンバー取得エラー:", err);
        } finally {
          this.isLoading = false;
        }
      },

      async addMember(shioriId, pageNo, checklistNo, assigneeCode) {
        try {
          const token = localStorage.getItem("token");
          await axios.post(
            `${API_URL}/checklist_detail_member/?shiori_id=${shioriId}&page_no=${pageNo}&checklist_no=${checklistNo}&assignee_code=${assigneeCode}`,
            {},
            withShioriAccessContext(shioriId, {
              headers: { Authorization: `Bearer ${token}` },
            }),
          );
        } catch (err) {
          console.error("メンバー追加エラー:", err);
          throw err;
        }
      },

      async toggleMemberComplete(shioriId, pageNo, checklistNo, assigneeCode) {
        try {
          const token = localStorage.getItem("token");
          const response = await axios.put(
            `${API_URL}/checklist_detail_member/${shioriId}/${pageNo}/${checklistNo}/${assigneeCode}`,
            {},
            withShioriAccessContext(shioriId, {
              headers: { Authorization: `Bearer ${token}` },
            }),
          );
          return response.data;
        } catch (err) {
          console.error("完了トグルエラー:", err);
          throw err;
        }
      },

      async removeMember(shioriId, pageNo, checklistNo, assigneeCode) {
        try {
          const token = localStorage.getItem("token");
          await axios.delete(
            `${API_URL}/checklist_detail_member/${shioriId}/${pageNo}/${checklistNo}/${assigneeCode}`,
            withShioriAccessContext(shioriId, {
              headers: { Authorization: `Bearer ${token}` },
            }),
          );
        } catch (err) {
          console.error("メンバー削除エラー:", err);
          throw err;
        }
      },
      clearShioriChecklistDetailMembers(shioriId) {
        if (String(this.loadedShioriId) !== String(shioriId)) return;
        this.checklistDetailMembers = [];
        this.loadedShioriId = null;
        this.error = null;
      },
    },
  },
);
